// extracted by mini-css-extract-plugin
export var deliveryRow = "_kb-a";
export var fixedHeight = "_kb-4";
export var freightLogo = "_kb-9";
export var fullWidth = "_kb-3";
export var priceColumn = "_kb-5";
export var radioSelected = "_kb-7";
export var radioUnselected = "_kb-6";
export var selectedOption = "_kb-2";
export var selectedOptionContainer = "_kb-1";
export var selection = "_kb-0";
export var tallSkeletonText = "_kb-8";